import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { NAV, LOGOS } from "../data/content";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 80);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled
            ? "bg-dodgers/90 backdrop-blur-md py-3"
            : "bg-transparent py-5"
        } text-galactico`}
        data-testid="site-header"
      >
        <div className="container-os flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3" data-testid="nav-logo">
            <img
              src={LOGOS.whiteWordmark}
              alt="OnSports"
              className="h-7 md:h-8 w-auto select-none"
              draggable="false"
            />
          </Link>
          <nav
            className="hidden lg:flex items-center gap-9"
            aria-label="Navigazione principale"
          >
            {NAV.map((item) => (
              <Link
                key={item.href}
                to={item.href}
                className={`text-[0.95rem] font-medium transition-opacity ${
                  location.pathname === item.href
                    ? "opacity-100"
                    : "opacity-70 hover:opacity-100"
                }`}
                data-testid={`nav-link-${item.href.replace(/\//g, "") || "home"}`}
              >
                {item.label}
              </Link>
            ))}
            <Link
              to="/contatti"
              className="btn-os btn-primary"
              data-testid="nav-cta-parliamone"
            >
              <span>Parliamone</span>
              <span className="arrow" aria-hidden="true">→</span>
            </Link>
          </nav>
          <button
            type="button"
            onClick={() => setOpen(true)}
            className="lg:hidden p-2 -mr-2"
            aria-label="Apri menu"
            data-testid="nav-mobile-open"
          >
            <Menu size={26} />
          </button>
        </div>
      </header>

      {/* Mobile fullscreen menu */}
      <div
        className={`fixed inset-0 z-[60] bg-dodgers text-galactico transition-transform duration-300 ${
          open ? "translate-x-0" : "translate-x-full"
        }`}
        aria-hidden={!open}
        data-testid="mobile-menu"
      >
        <div className="container-os pt-6 pb-10 flex flex-col h-full">
          <div className="flex items-center justify-between">
            <img src={LOGOS.whiteWordmark} alt="OnSports" className="h-7" />
            <button
              type="button"
              onClick={() => setOpen(false)}
              aria-label="Chiudi menu"
              className="p-2 -mr-2"
              data-testid="nav-mobile-close"
            >
              <X size={28} />
            </button>
          </div>
          <nav className="flex flex-col gap-6 mt-14" aria-label="Menu mobile">
            {NAV.map((item, idx) => (
              <Link
                key={item.href}
                to={item.href}
                className="font-display text-4xl leading-none"
                data-testid={`mobile-nav-link-${idx}`}
              >
                {item.label}
              </Link>
            ))}
          </nav>
          <div className="mt-auto">
            <Link to="/contatti" className="btn-os btn-primary" data-testid="mobile-nav-cta">
              <span>Parliamone</span>
              <span className="arrow" aria-hidden="true">→</span>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
